module.exports = __webpack_public_path__ + "media/file_icons/xls-a4040f83.svg";